import React from 'react';
import {
  Box,
  Button,
  Stack,
  Typography
} from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useNavigate } from 'react-router-dom';

import { useClientZS } from '../../pages/ClientZS';
import { EventDetailsCard } from './main-page/EventDetailsCard';
import { PaymentsCard } from './main-page/PaymentsCard';
import { DocumentsCard } from './main-page/DocumentsCard';


export const MainPageDetails = () => {
  const { orderData, purchaserData } = useClientZS();
  const navigate = useNavigate();

  if (!orderData) {
    return (
      <Stack spacing={3} alignItems="center">
        <Typography variant="h5" textAlign="center">
          Brak zamówień
        </Typography>

        <Button
          variant="contained"
          startIcon={<OpenInNewIcon />}
          onClick={() => window.open('https://crm.scenerio.pl/formularze/rezerwacja-sunsport-2027', '_blank')}
        >
          Przejdź do formularza
        </Button>
      </Stack>
    );
  }

  return (
    <Box
      sx={{
        width: '100%'
      }}
    >
      <Stack
        direction={{ xs: 'column', lg: 'row' }}
        spacing={4}
        alignItems="flex-start"
      >
        {/* LEWA KOLUMNA */}

        <Box flex={2} width="100%">
          <EventDetailsCard orderData={orderData} />
        </Box>

        {/* PRAWA KOLUMNA */}

        <Box flex={0.5} width="100%">
          <PaymentsCard orderData={orderData} />
        </Box>

        <Box flex={0.5} width="100%">
          <DocumentsCard />
        </Box>

      </Stack>
    </Box>
  );
};
